import axios from "axios";
import { OktaAuth } from "@okta/okta-auth-js";
import { getToken } from "../utility/tokenOperations";
import config from "../authentication/config";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
  failedQueue = [];
};

const fetchClient = () => {
  const defaultOptions = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  // Create instance
  let axiosInstance = axios.create(defaultOptions);
  const oktaAuth = new OktaAuth(config.oidc);

  /**  Set the AUTH token for any request*/
  axiosInstance.interceptors.request.use(function (config) {
    let token = getToken();
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers["Controller"] = sessionStorage.getItem("Controller") ?? "";
    config.headers["Action"] = sessionStorage.getItem("Action") ?? "";
    config.headers["Path"] = sessionStorage.getItem("Path") ?? "";
    config.headers["Location"] = sessionStorage.getItem("userLocation") ?? "";
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status !== 401 || originalRequest._retry) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => {
          originalRequest.headers.Authorization = `Bearer ${getToken()}`;
          return axiosInstance(originalRequest);
        });
      }

      isRefreshing = true;

      try {
        const renewedTokens = await oktaAuth.token.renewTokens();
        oktaAuth.tokenManager.setTokens(renewedTokens);
        processQueue(null);
        originalRequest.headers.Authorization = `Bearer ${getToken()}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        oktaAuth.tokenManager.clear();
        window.location.reload();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
  );

  return axiosInstance;
};

export default fetchClient();
